import { defineStore } from 'pinia'

export const useContactStore = defineStore('contact', () => {
  const formEnabled = ref(false)
  const description = ref('')
  const phoneNumbers = ref<string[]>([])
  const fullAddress = ref('')
  const officeHours = ref('')
  const address = ref('')
  const subDistrict = ref('')
  const district = ref('')
  const province = ref('')
  const zipcode = ref('')
  const email = ref('')
  const facebookId = ref('')
  const lineId = ref('')
  const instagramId = ref('')
  const whatsappId = ref('')
  const youtubeLink = ref('')
  const tiktokLink = ref('')
  const metaTitleFront = ref('')
  const metaDescriptionFront = ref('')
  const enableButton = ref({
    facebook: false,
    line: false,
    tel: false,
    whatsapp: false,
  })
  const { $api } = useNuxtApp()

  const fetch = async () => {
    const response = await $api<ApiSuccessResponse<Contact>>('/contact')
    const data = response.data
    if (data) {
      update(data)
    }
  }

  const update = (payload: Contact) => {
    formEnabled.value = payload.formEnabled
    description.value = payload.description
    phoneNumbers.value = payload.phoneNumbers
    fullAddress.value = payload.fullAddress || [payload.address, payload.subDistrict, payload.district, payload.province, payload.zipcode].filter(Boolean).join(' ')
    officeHours.value = payload.officeHours
    address.value = payload.address
    subDistrict.value = payload.subDistrict
    district.value = payload.district
    province.value = payload.province
    zipcode.value = payload.zipcode
    email.value = payload.email
    facebookId.value = payload.facebookId
    lineId.value = payload.lineId
    instagramId.value = payload.instagramId
    whatsappId.value = payload.whatsappId
    youtubeLink.value = payload.youtubeLink
    tiktokLink.value = payload.tiktokLink
    metaTitleFront.value = payload.metaTitleFront
    metaDescriptionFront.value = payload.metaDescriptionFront
    enableButton.value = payload.enableButton
  }

  return {
    formEnabled,
    description,
    phoneNumbers,
    fullAddress,
    officeHours,
    address,
    subDistrict,
    district,
    province,
    zipcode,
    email,
    facebookId,
    lineId,
    instagramId,
    whatsappId,
    youtubeLink,
    tiktokLink,
    metaTitleFront,
    metaDescriptionFront,
    enableButton,
    fetch,
    update,
  }
})
